import { render } from "./CompanySetup.vue?vue&type=template&id=5854e8fc"
import script from "./CompanySetup.vue?vue&type=script&lang=js"
export * from "./CompanySetup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__